import { useEffect, useState } from 'react';
import { useMainContext } from '../../core/contexts/main';
import { useWindowSize } from '../../core/hooks/useWindowSize';
import { useGetContactsList } from '../../core/services/react-query/useContact';
import Text from '../../core/utils/Text';
import { Link } from 'react-router-dom';
import { PaginationContainer } from '../../styles/CommonStyles';
import Pagination from 'react-js-pagination';
import { getMainTheme } from '../../core/utils/theme';
import { ClipLoader } from 'react-spinners';
import { TbStar, TbStarOff, TbUser } from 'react-icons/tb'; // Add icons for star and user

export default function ContactsList({ setReceiverId }) {
	const { width } = useWindowSize();
	const {
		main: { theme },
	} = useMainContext();

	const [activePage, setActivePage] = useState(1);
	const [allPages, setAllPages] = useState(null);
	const [selectedId, setSelectedId] = useState(null)
	const { data, isLoading: contactsLoading, refetch } = useGetContactsList(activePage);
	const contacts = data?.data;
	const meta = data?.meta;

	useEffect(() => {
		if (contacts && (allPages !== meta.total || !allPages)) {
			setAllPages(meta.total);
		}
	}, [contacts]);

	useEffect(refetch, [activePage]);

	const onPageChange = (page) => {
		setActivePage(page);
	};

	const handleSelectReceiverId = (contact) => {
		if (width > 1024) {
			setSelectedId((prevSelectedId) =>
				prevSelectedId === contact.contactId ? null : contact.contactId
			);
		} else {
			setReceiverId(contact.contactId);
		}
	};



	const handleSetReceiverId = () => {
		setReceiverId(selectedId)
	}

	return (
		<>
			<div className=" w-full max-w-md mx-auto rounded-2xl bg-white shadow-lg dark:bg-gray-800 text-white relative">
				<div className='flex justify-center items-center px-4 py-2 h-[67px] bg-black rounded-t-2xl w-full'>
					<h2 className='text-lg font-semibold  text-center'>
						<Text tid='my-contacts' />
					</h2>
				</div>
				{!contactsLoading ? (
					contacts.length ? (
						<div className="flex flex-col gap-y-2 h-[300px] overflow-y-auto py-2">
							{contacts.map((contact) => {
								const fullname = `${contact.contact.firstName ?? '--'} ${contact.contact.lastName ?? '--'}`;

								return (
									<div
										className="flex items-center justify-between p-2 px-4 cursor-pointer dark:hover:bg-gray-600 hover:bg-gray-200 transition"
										onClick={() => handleSelectReceiverId(contact)}
										key={contact._id}
									>
										<div className="flex items-center gap-2">
											<TbUser size={32} className="text-gray-300" />
											<div>
												<p className="font-semibold text-secondaryBg dark:text-white">{fullname}</p>
												<p className="text-xs text-gray-400">{contact.contactId}</p>
											</div>
										</div>
										<TbStar
											size={20}
											className={contact.contactId === selectedId ? 'text-yellow-400 fill-yellow-400' : 'text-gray-400'}
										/>
									</div>
								);
							})}
						</div>
					) : (
						<div className="flex flex-col items-center justify-center min-h-[260px] text-center">
							<Text tid="no-contact-added" className="text-sm text-gray-400" />
							<Link to="/contacts" className="text-sm text-blue-400 mt-3">
								<Text tid={'goto-contacts'} />
							</Link>
						</div>
					)
				) : (
					<div className="flex items-center justify-center min-h-[260px]">
						<ClipLoader size={32} color={getMainTheme().mainOrange} />
					</div>
				)}
				<div className="flex justify-center gap-4 p-4">
					{
						width > 1024 ? (<button onClick={() => { handleSetReceiverId() }} className="bg-active text-white py-2 px-4 rounded-lg w-full">
							<Text tid={'choose'} />
						</button>) : null
					}
					<Link to="/contact" className="bg-transparent border border-active text-primaryBg dark:text-white py-2 px-4 rounded-lg w-full flex justify-center">
						<Text tid={'add-contacts'} /></Link>
				</div>
			</div>
		</>
	);
}
